import { render, staticRenderFns } from "./message-inform.vue?vue&type=template&id=db93f3b4&scoped=true&"
import script from "./message-inform.vue?vue&type=script&lang=js&"
export * from "./message-inform.vue?vue&type=script&lang=js&"
import style0 from "./message-inform.vue?vue&type=style&index=0&id=db93f3b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db93f3b4",
  null
  
)

export default component.exports